import qs from "qs";
import { soddApi } from "./soddApi";

function formatParams(params) {
    return qs.stringify(params, {
        arrayFormat: "brackets",
        skipNulls: true,
        filter: (prefix, value) => value || undefined,
    });
}

export const dashboardApi = soddApi
    .enhanceEndpoints({
        addTagTypes: ["dashboard", "kpi"],
    })
    .injectEndpoints({
        endpoints: (build) => ({
            getKpiRawDataById: build.query({
                query: ({ id }) => ({
                    url: "api/v1/graphs/raw-data/kpi",
                    params: { id },
                }),
                providesTags: (result, error, { id }) => [{ type: "kpi", id }],
            }),
            getAllDashboards: build.query({
                query: () => ({ url: `api/v1/dashboards` }),
                providersTags: ["dashboard"],
            }),
            getDashboardById: build.query({
                query: ({ dashboardId }) => ({
                    url: `api/v1/dashboards/${dashboardId}`,
                }),
                providersTags: (result) =>
                    result
                        ? [
                              "dashboard",
                              ...result.map(({ dashboardId }) => ({
                                  type: "dashboard",
                                  id: dashboardId,
                              })),
                          ]
                        : "dashboard",
            }),
        }),
    });
